// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';

// INNER IMPORTS
import './toggle-btn.css';

const ToggleBtn = ({ isChecked, toggle, style  }) => {


    return (
        <div className="toggle-btn-wrapper" style={style}>
            <input
                className="toggle-btn"
                type="checkbox"
                id="switch"
                name="switch"
                checked={isChecked}
                onChange={toggle}
            />
            <label htmlFor="switch"></label>
        </div>
    )
};

ToggleBtn.propTypes = {
    isChecked: PropTypes.bool,
    toggle: PropTypes.func,
    style: PropTypes.object
};

export default ToggleBtn;



// WEBPACK FOOTER //
// ./src/Components/Elements/Inputs/ToggleBtn.js